import * as THREE from "three";

const maps = [
  'map',
  'lightMap',
  'aoMap',
  'emissiveMap',
  'bumpMap',
  'normalMap',
  'displacementMap',
  'roughnessMap',
  'metalnessMap',
  'alphaMap',
  'envMaps',
  'envMap',
  'specularMap',
  'gradientMap',
];

export default function disposeObject3D(scene) {
  scene.traverse((obj) => {
    if (obj instanceof THREE.Mesh) {
      if (obj.material) {
        // obj.material.dispose(); 

        maps.forEach((map) => {
          if (obj.material[map]) {
            // obj.material[map].dispose();
            // obj.material[map] = null;  
          }
        });
      }

      if (obj.geometry) {
        obj.geometry.dispose();
      }

      if (obj.texture) {
        obj.texture.dispose();
        obj.texture = {};
      }

      if (obj.bufferGeometry) {
        obj.bufferGeometry.dispose();
      }
    }
  });
}
